// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  stripe: 'pk_live_51JNMydG2U7avPAtRc9TDYWi5e2ybwuIMpy35zM8Gewcm3Rtte1CE3mYgW8t2yHpmVupVZ4C4Nkd9qinRGEC0rOFG00iqpL0XGy',
  serverUrl: '/api',
 firebase : {
  apiKey: "AIzaSyCDZCex5t2EvNUcMGviaY1F2toqgx33HpM",
  authDomain: "sustainibleapi.firebaseapp.com",
 // databaseURL: "https://sustainibleprod.firebaseio.com",
  databaseURL: "https://sustainibleapi.firebaseio.com",
  projectId: "sustainibleapi",
  storageBucket: "sustainibleapi.appspot.com",
  messagingSenderId: "353790608315",
  appId: "1:353790608315:web:b586dd14a55e305bbd7a9e",
  measurementId: "G-HWGVBCRCBW"
   }
  /* firebase: {
    apiKey: "AIzaSyBEavnfguoooFuhqVfQHxOgNBQoDQd3rtA",
    authDomain: "sustainible-dev.firebaseapp.com",
    databaseURL: "https://sustainible-dev.firebaseio.com",
    projectId: "sustainible-dev",
    storageBucket: "sustainible-dev.appspot.com",
    messagingSenderId: "772000946290",
    appId: "1:772000946290:web:0fd83d37f88bd1744acaeb",
    measurementId: "G-1SR946XCFE"
  }*/
}

export const environmentDummy = {
  production: false,
  // firebase: {
  //   apiKey: "AIzaSyBEavnfguoooFuhqVfQHxOgNBQoDQd3rtA",
  //   authDomain: "sustainible-dev.firebaseapp.com",
  //   databaseURL: "https://sustainible-dev.firebaseio.com",
  //   projectId: "sustainible-dev",
  //   storageBucket: "sustainible-dev.appspot.com",
  //   messagingSenderId: "772000946290",
  //   appId: "1:772000946290:web:0fd83d37f88bd1744acaeb",
  //   measurementId: "G-1SR946XCFE"
  // }
  firebase: {
    apiKey: 'AIzaSyBEavnfguoooFuhqVfQHxOgNBQoDQd3rtA',
    authDomain: 'sustainible-dev.firebaseapp.com',
    databaseURL: 'https://sustainible-dev.firebaseio.com',
    projectId: 'sustainible-dev',
    storageBucket: 'sustainible-dev.appspot.com',
    messagingSenderId: '772000946290',
    appId: '1:772000946290:web:0fd83d37f88bd1744acaeb',
    measurementId: 'G-1SR946XCFE',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
